// extracted by mini-css-extract-plugin
export default {"main":"Article_main__9WRCy","title":"Article_title__QuvOJ","video":"Article_video__zlsVI"};